// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button[data-v-1e01c8ec],div[data-v-1e01c8ec]{align-items:center;display:inline-flex}.google-translate[data-v-1e01c8ec]{flex-wrap:wrap;gap:1em;margin:.5em 0;row-gap:.25em}.icon[data-v-1e01c8ec]{margin:-.3em .4em -.3em -.1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
